import { useUIStore } from 'Modules/ui/index.store';
import React from "react";
import { Styled } from "../index.styles";
import { BannerActionsProps } from "./index.types";

/**
 * Banner Actions Component
 * @param BannerActionsProps
 * @returns React.ReactElement
 */
export const BannerActions = ({
  actions,
  variant,
}: BannerActionsProps): React.ReactElement => {
  const setImagePreviewOpen = useUIStore((state) => state.setImagePreviewOpen);

  return (
    <Styled.ActionContainer $variant={variant}>
      {actions.map((action, index) => (
        <Styled.Action
          key={index}
          onClick={() => {
            // Ensure image preview is closed when a banner action is triggered
            setImagePreviewOpen(false);
            action.onClick();
          }}
        >
          {action.label}
        </Styled.Action>
      ))}
    </Styled.ActionContainer>
  );
};